import Dropdown from './Dropdown';

Dropdown.install = function(Vue) {
  Vue.component(Dropdown.name, Dropdown);
}

export default Dropdown;